import React from "react";
import {TAB_SERVICES} from "../../../constants/company";
import {videoBanner, seo} from "../../../constants/services";

import ReviewsSection from "../../Shared/Reviews";
import FAQWrapper from "../../Shared/wrappers/FAQWrapper";
import VideoBannerWrapper from "../../Shared/wrappers/VideoBannerWrapper";
import Seo from "../../Shared/Seo";
import Services from "./Components/Service/Services";

const ServicesWrapper = () => {
  return <div className="services-page">
    <Seo title={seo.title} description={seo.description} />
    <VideoBannerWrapper   
      title={videoBanner.title}
      description={videoBanner.description}
      video={videoBanner.video}
      eventAction={videoBanner.eventLabel}
      eventLabel={videoBanner.eventLabel}
      altText={videoBanner.altText}
    />
    <Services />
    <div className='bg-white'>
      <ReviewsSection/>
    </div>
    <div className='bg-white'>
      <FAQWrapper initialTab={TAB_SERVICES}/>
    </div>
  </div>
}

export default ServicesWrapper;